/* eslint-disable import/prefer-default-export */
import { differenceInHours } from 'date-fns';
import { put, select, takeLatest, takeLeading } from 'redux-saga/effects';

import API, {
  LOGIN_SESSION_LIFETIME_HOURS,
  TOKEN_MAX_REFRESH_HOURS,
  TOKEN_MIN_REFRESH_HOURS
} from '@sm/api';
import { axiosCall, sendTextError, TOKEN_REFRESH_PERIOD_EXPIRED } from '@utils';
import {
  setNetworkActivityAction,
  setNotificationMsgAction,
  setTokenAction,
  setTokenRefreshExpiredAction
} from 'seller/store/actions';
import { loginSelector } from 'seller/store/reducers';
import { REFRESH_TOKEN, RESET_PASSWORD, SETUP_NEW_PASSWORD } from './action';

export function* refreshTokenSaga() {
  const { tokenDate, token, tokenRefreshExpired: refreshFailed, tokenRefreshedAt } = yield select(
    loginSelector
  );
  const now = Date.now();
  try {
    const lastLoginHoursAgo = tokenDate ? differenceInHours(now, new Date(+tokenDate)) : Infinity;
    const lastRefreshedHoursAgo = tokenRefreshedAt
      ? differenceInHours(now, new Date(+tokenRefreshedAt))
      : Infinity;
    console.log({
      lastLoginHoursAgo,
      lastRefreshedHoursAgo,
      tokenDate,
      tokenRefreshedAt,
      refreshFailed
    });
    // -1 hour safety margin to prevent failed HTTP requests due to edge cases
    const loginExpired = lastLoginHoursAgo >= LOGIN_SESSION_LIFETIME_HOURS - 1;
    const refreshExpired = lastRefreshedHoursAgo >= TOKEN_MAX_REFRESH_HOURS - 1;
    const minRefreshTimePassed = lastRefreshedHoursAgo >= TOKEN_MIN_REFRESH_HOURS;
    if (refreshFailed || loginExpired || refreshExpired || !minRefreshTimePassed) return;
    const { data } = yield axiosCall.post(API.refreshToken, { token });
    yield put(setTokenAction(data.token, null, Date.now()));
  } catch (error) {
    if (error?.response?.data?.non_field_errors?.[0] === TOKEN_REFRESH_PERIOD_EXPIRED) {
      yield put(setTokenRefreshExpiredAction(true));
    }
    console.log('refreshSaga error', error);
  }
}

function* resetPasswordSaga({ payload }) {
  try {
    yield put(setNetworkActivityAction(true));
    const { callback, email } = payload;
    yield axiosCall.post(API.password.reset, { email });
    if (callback) callback();
  } catch (e) {
    yield put(setNotificationMsgAction('Sending email for password recovery failed'));
  } finally {
    yield put(setNetworkActivityAction(false));
  }
}

function* setupNewPasswordSaga({ payload }) {
  yield put(setNetworkActivityAction(true));
  const { password, userId, token, callback } = payload;
  try {
    if (!userId || !token) {
      if (callback) callback(false);
      return;
    }
    yield axiosCall.post(API.password.resetDone, { uid: userId, token, new_password: password });
    if (callback) callback(true);
  } catch (error) {
    if (callback) callback(false);
    sendTextError('setupNewPasswordSaga error', error);
  } finally {
    yield put(setNetworkActivityAction(false));
  }
}

export function* loginSagaWatcher() {
  yield takeLeading([REFRESH_TOKEN], refreshTokenSaga);
  yield takeLatest(RESET_PASSWORD, resetPasswordSaga);
  yield takeLatest(SETUP_NEW_PASSWORD, setupNewPasswordSaga);
}
